import { useRef, useState } from "react";
import {
  Button,
  IconButton,
  Tooltip,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import html2pdf from "html2pdf.js";
import logoImage from "../../components/assets/images/Logo/transparency background/Little Haiti Global-08.png";
import { s3baseUri } from "../../config/config";
import DownloadIcon from "@mui/icons-material/Download";
import VisibilityIcon from "@mui/icons-material/Visibility";
import EditIcon from "@mui/icons-material/Edit";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DescriptionIcon from "@mui/icons-material/Description";
import AssignmentIndIcon from "@mui/icons-material/AssignmentInd";
import { useNavigate } from "react-router-dom";
import { visa_application } from "../../components/SideBarData/SidebarData";

const FileManagement = ({ form, isAddon, mode = "icons", onEdit }) => {
  const navigate = useNavigate();
  const pdfRef = useRef();
  const [loading, setLoading] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDownloadPDF = () => {
    setLoading(true);
    const element = pdfRef.current;

    element.querySelectorAll("div, p, span").forEach((el) => {
      el.style.fontSize = "20px";
    });

    const filename = form?.case_number
      ? `${form.case_number}.pdf`
      : form?.addon_info
      ? `${form.addon_info.first_name}_${form.addon_info.last_name}_application.pdf`
      : "form-data.pdf";

    // old code:
    // filename: `${form?.case_number || "form-data"}.pdf`,

    const opt = {
      margin: 0.5,
      filename: filename,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
      pagebreak: { mode: ["avoid-all", "css", "legacy"] },
    };

    html2pdf()
      .set(opt)
      .from(element)
      .save()
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        console.error("PDF generation failed:", error);
        setLoading(false);
      });
  };

  const formData = form?.form || [];
  const mergedForm = visa_application.map((templateSection) => {
    const existingSection = formData.find(
      (s) => s.value === templateSection.value
    );
    let section = existingSection
      ? JSON.parse(JSON.stringify(existingSection))
      : JSON.parse(JSON.stringify(templateSection));

    return section;
  });

  const filteredSections = mergedForm
    ?.filter((section) => section?.value !== "processing_fee_and_submission")
    ?.map((section) => ({
      ...section,
      questions: section?.questions?.filter((q) => {
        const globalExcluded =
          q.question_type === "statement" || q.question_type === "boxwithcheck";
        if (section?.value === "certification") {
          return (
            !globalExcluded &&
            q.question_type !== "description" &&
            q.question_type !== "heading"
          );
        }
        return !globalExcluded;
      }),
    }));

  const checkcountry =
    mergedForm
      ?.find((q) => q.value === "visa_type_and_application_details")
      ?.questions?.find((q) => q.created_for === "country_of_residence")
      ?.answer === "haiti";

  const updatedData = filteredSections
    ?.filter((s) => !s.hide_section)
    .map((section) => {
      if (section?.value === "required_documentation") {
        return {
          ...section,
          questions: section?.questions.filter((q) => {
            if (q.created_for === "dcpj_data_page") {
              return checkcountry;
            }
            return true;
          }),
        };
      }
      // remove housing options nested questions from pdf if housing_need is not 'yes'
      if (section?.value === "housing_option") {
        const housingNeed = section?.questions.find(
          (q) => q.created_for === "housing_need"
        )?.answer;

        if (housingNeed !== "yes") {
          return {
            ...section,
            questions: section.questions.filter(
              (q) => q.created_for === "housing_need"
            ),
          };
        }
      }

      return section;
    });

  const areAllSectionsCompleted = (formSections) => {
    if (!Array.isArray(formSections)) return false;
    return formSections?.every((section) => {
      if (
        section?.has_sub_sections &&
        Array.isArray(section?.sub_sections) &&
        section?.sub_sections?.length > 0
      ) {
        return section?.sub_sections?.every((sub) => sub?.is_completed);
      }
      return section?.is_completed;
    });
  };

  const handleView = () => {
    if (isAddon && form?._id) {
      navigate(`/application-detail?addon_id=${form._id}`);
    } else {
      navigate("/application-detail");
    }
  };

  return (
    <>
      {mode === "icons" ? (
        <>
          <Tooltip title="Download Form">
            <IconButton
              onClick={handleDownloadPDF}
              disabled={loading}
              color="primary"
            >
              <DownloadIcon />
            </IconButton>
          </Tooltip>

          <Tooltip title="View Form">
            <IconButton onClick={handleView} color="primary">
              <VisibilityIcon />
            </IconButton>
          </Tooltip>
        </>
      ) : (
        <>
          <IconButton
            id="fade-button"
            aria-controls={open ? "fade-menu" : undefined}
            aria-haspopup="true"
            aria-expanded={open ? "true" : undefined}
            onClick={handleClick}
            color="primary"
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            id="fade-menu"
            MenuListProps={{
              "aria-labelledby": "fade-button",
            }}
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            transformOrigin={{ horizontal: "right", vertical: "top" }}
            anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
          >
            <MenuItem
              onClick={() => {
                handleView();
                handleClose();
              }}
            >
              <ListItemIcon>
                <VisibilityIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>View</ListItemText>
            </MenuItem>
            {onEdit && (
              <MenuItem
                onClick={() => {
                  onEdit();
                  handleClose();
                }}
              >
                <ListItemIcon>
                  <EditIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText>Edit Add-on</ListItemText>
              </MenuItem>
            )}
            <MenuItem
              onClick={() => {
                handleDownloadPDF();
                handleClose();
              }}
              disabled={loading}
            >
              <ListItemIcon>
                <DownloadIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Download</ListItemText>
            </MenuItem>

            <MenuItem
              disabled={!(form?.background_screen_files?.length > 0)}
              onClick={() => {
                if (form?.background_screen_files?.length > 0) {
                  window.open(s3baseUri + form.background_screen_files[0].path);
                }
                handleClose();
              }}
            >
              <ListItemIcon>
                <DescriptionIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Background Screening</ListItemText>
            </MenuItem>

            <MenuItem
              disabled={!(form?.external_files?.length > 0)}
              onClick={() => {
                if (form?.external_files?.length > 0) {
                  window.open(s3baseUri + form.external_files[0].path);
                }
                handleClose();
              }}
            >
              <ListItemIcon>
                <AssignmentIndIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText>Visa File</ListItemText>
            </MenuItem>
          </Menu>
        </>
      )}
      <div className="pdf-content">
        <div ref={pdfRef}>
          <div style={{ textAlign: "center", marginBottom: "20px" }}>
            <img src={logoImage} alt="Logo" width={120} height={120} />
          </div>
          {updatedData?.map((section, sectionIndex) => {
            return (
              <div
                key={sectionIndex}
                style={{
                  marginBottom: "20px",
                }}
              >
                <h2>{section?.title}</h2>
                {section?.value === "getting_started" && (
                  <h4>Eligibility Certification Statement</h4>
                )}
                {section?.intro_text && <p>{section?.intro_text}</p>}
                <hr />

                {section?.questions?.map((q, qIndex) => {
                  const ans = q?.answer;

                  return (
                    <div
                      key={qIndex}
                      style={{
                        marginBottom: "15px",
                        pageBreakInside: "avoid",
                        breakInside: "avoid",
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{
                          __html: q.question_statement,
                        }}
                      />
                      {!q.is_not_show_ans && (
                        <>
                          <br />
                          <strong>Answer:</strong>{" "}
                          {Array.isArray(ans) ? (
                            ans.map((file, i) => {
                              const filePath =
                                typeof file === "string" ? file : file?.path;

                              return filePath?.startsWith("file") ? (
                                <span key={i}>
                                  <a
                                    href={`${s3baseUri}${filePath}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {`${s3baseUri}${filePath}`}
                                  </a>
                                </span>
                              ) : (
                                <span key={i}>
                                  {filePath || "Not answered"}
                                </span>
                              );
                            })
                          ) : typeof ans === "string" &&
                            ans?.startsWith("file") ? (
                            <a
                              href={`${s3baseUri}${ans}`}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {`${s3baseUri}${ans}`}
                            </a>
                          ) : section?.value ===
                              "language_assessment_support_services" ||
                            section?.value ===
                              "optional_wellness_support_services" ||
                            section?.value === "housing_option" ||
                            section?.value ===
                              "visa_type_and_application_details" ? (
                            q?.options ? (
                              q.options.find((opt) => opt.value === ans)
                                ?.label ||
                              ans ||
                              "N/A"
                            ) : (
                              ans || "N/A"
                            )
                          ) : q?.question_type === "file" ? (
                            ans || "No file uploaded"
                          ) : (
                            ans || "N/A"
                          )}
                        </>
                      )}
                    </div>
                  );
                })}
                {/* Sub-sections */}
                {section?.sub_sections?.map((sub, subIndex) => (
                  <div key={subIndex} style={{ marginBottom: "20px" }}>
                    <h3>{sub.title}</h3>
                    {sub.questions?.map((q, qIndex) => (
                      <div
                        key={qIndex}
                        style={{
                          marginBottom: "15px",
                          pageBreakInside: "avoid",
                          breakInside: "avoid",
                        }}
                      >
                        <div
                          dangerouslySetInnerHTML={{
                            __html: q.question_statement,
                          }}
                        />
                        {!q.is_not_show_ans && (
                          <>
                            <br />
                            <strong className="mt-2">Answer:</strong>{" "}
                            {Array.isArray(q.answer)
                              ? q.answer.map((file, i) => (
                                  <span key={i}>
                                    <a
                                      href={`${s3baseUri}${file.path}`}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {s3baseUri}
                                      {file.path}
                                    </a>
                                  </span>
                                ))
                              : section?.value ===
                                  "language_assessment_support_services" ||
                                section?.value ===
                                  "optional_wellness_support_services" ||
                                section?.value === "housing_option" ||
                                section?.value ===
                                  "visa_type_and_application_details"
                              ? q?.options
                                ? q.options.find(
                                    (opt) => opt.value === q.answer
                                  )?.label ||
                                  q.answer ||
                                  "N/A"
                                : q.answer || "N/A"
                              : q?.question_type === "file"
                              ? q.answer || "No file uploaded"
                              : q.answer || "N/A"}
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                ))}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
};

export default FileManagement;
